module.exports = __webpack_public_path__ + "img/fond-botanique.0596a122.png";